<template>
  <section class="budget_box">
    <ax-panel title="预算金额" v-if="budget.budgetUse">
      <van-cell title="预算情况："></van-cell>
      <van-cell title="主预算金额">{{budget.budgetUse.sourceBudget | money}}</van-cell>
      <van-cell title="追加预算总金额">{{budget.budgetUse.appendTotalBudget | money}}</van-cell>
      <van-cell title="预算总金额">{{budget.budgetUse.totalBudget | money}}</van-cell>
      <van-cell class="top-item" title="付款情况："></van-cell>
      <van-cell title="已付款金额">{{budget.budgetUse.payBudget | money}}</van-cell>
      <van-cell title="在途预提金额">{{budget.budgetUse.prepareBudget | money}}</van-cell>
      <van-cell title="付款总金额">{{budget.budgetUse.usedBudget | money}}</van-cell>
      <van-cell title="剩余金额">{{budget.budgetUse.lastBudget | money}}</van-cell>
      <van-cell class="top-item" title="旧OA系统："></van-cell>
      <van-cell title="已付款金额">{{budget.budgetUse.oldOaPaid | money}}</van-cell>
      <van-cell title="在途付款金额">{{budget.budgetUse.oldOaTransit | money}}</van-cell>
      <van-cell title="付款总金额">{{budget.budgetUse.oldOaUsedBudget | money}}</van-cell>
    </ax-panel>

    <ax-panel title="关联合同情况" v-if="budget.contracts">
      <div v-for="(item, index) in budget.contracts" :key="index" v-if="index<1">
        <van-cell :class="{'top-item':index!==0}" title="合同单号" :value="item.billNo"></van-cell>
        <van-cell title="合同名称" :value="item.name"></van-cell>
        <van-cell title="合同金额">{{item.amount}}</van-cell>
        <van-cell title="申请人">{{item.createUserId}}</van-cell>
        <van-cell title="状态">
          <span class="status_span" v-html="item.instStatus"></span>
        </van-cell>
      </div>
      <ax-fold>
        <div v-for="(item, index) in budget.contracts" :key="index" v-if="index>0">
          <van-cell :class="{'top-item':index!==0}" title="合同单号" :value="item.billNo"></van-cell>
          <van-cell title="合同名称" :value="item.name"></van-cell>
          <van-cell title="合同金额">{{item.amount}}</van-cell>
          <van-cell title="申请人">{{item.createUserId}}</van-cell>
          <van-cell title="状态">
            <span class="status_span" v-html="item.instStatus"></span>
          </van-cell>
        </div>
      </ax-fold>
    </ax-panel>

    <ax-panel title="关联付款情况" v-if="budget.pays">
      <div v-for="(item, index) in budget.pays" :key="index" v-if="index<1">
        <van-cell :class="{'top-item':index!==0}" title="付款申请编号" :value="item.paymentNumber"></van-cell>
        <van-cell title="付款名称" :value="item.paymentSummary"></van-cell>
        <van-cell title="付款金额">{{item.occupyAmount | money}}</van-cell>
        <van-cell title="申请人">{{item.createUserId}}</van-cell>
        <van-cell title="状态">
          <span class="status_span" v-html="item.instStatus"></span>
        </van-cell>
      </div>
      <ax-fold>
        <div v-for="(item, index) in budget.pays" :key="index" v-if="index>0">
          <van-cell :class="{'top-item':index!==0}" title="付款申请编号" :value="item.paymentNumber"></van-cell>
          <van-cell title="付款名称" :value="item.paymentSummary"></van-cell>
          <van-cell title="付款金额">{{item.occupyAmount | money}}</van-cell>
          <van-cell title="申请人">{{item.createUserId}}</van-cell>
          <van-cell title="状态">
            <span class="status_span" v-html="item.instStatus"></span>
          </van-cell>
        </div>
      </ax-fold>
    </ax-panel>
    
    <ax-panel title="其他单据使用情况" v-if="budget.others">
      <div v-for="(item, index) in budget.others" :key="index" v-if="index<1">
          <van-cell :class="{'top-item':index!==0}" title="数据类型" v-model="item.applyType"></van-cell>
          <van-cell title="申请编号" v-model="item.applyCode"></van-cell>
          <van-cell title="申请人">
              {{item.applyUserName}}
          </van-cell>
          <van-cell title="标题">
              {{item.subject}}
          </van-cell>
          <van-cell title="占用金额">
              {{item.budgetOccupancyAmount | money}}
          </van-cell>
          <van-cell title="状态">
              <span class="status_span" v-html="item.instStatus"></span>
          </van-cell>
      </div>
      <ax-fold>
        <div v-for="(item, index) in budget.others" :key="index" v-if="index>0">
          <van-cell :class="{'top-item':index!==0}" title="数据类型" v-model="item.applyType"></van-cell>
          <van-cell title="申请编号" v-model="item.applyCode"></van-cell>
          <van-cell title="申请人">
              {{item.applyUserName}}
          </van-cell>
          <van-cell title="标题">
              {{item.subject}}
          </van-cell>
          <van-cell title="占用金额">
              {{item.budgetOccupancyAmount | money}}
          </van-cell>
          <van-cell title="状态">
              <span class="status_span" v-html="item.instStatus"></span>
          </van-cell>
      </div>
      </ax-fold>
    </ax-panel>
    
    <ax-panel title="关联追加预算情况" v-if="budget.appendBudgets">
      <div v-for="(item, index) in budget.appendBudgets" :key="index" v-if="index<1">
        <van-cell :class="{'top-item':index!==0}" title="追加预算编号" :value="item.code"></van-cell>
        <van-cell title="追加预算名称" :value="item.businessName"></van-cell>
        <van-cell title="追加预算金额">{{item.totalBudget | money}}</van-cell>
        <van-cell title="申请人">{{item.createUserId}}</van-cell>
        <van-cell title="状态">
          <span class="status_span" v-html="item.instStatus"></span>
        </van-cell>
      </div>
      <ax-fold>
        <div v-for="(item, index) in budget.appendBudgets" :key="index" v-if="index>0">
          <van-cell :class="{'top-item':index!==0}" title="追加预算编号" :value="item.code"></van-cell>
          <van-cell title="追加预算名称" :value="item.businessName"></van-cell>
          <van-cell title="追加预算金额">{{item.totalBudget | money}}</van-cell>
          <van-cell title="申请人">{{item.createUserId}}</van-cell>
          <van-cell title="状态">
            <span class="status_span" v-html="item.instStatus"></span>
          </van-cell>
        </div>
      </ax-fold>
    </ax-panel>
  </section>
</template>
<script>
import { fetchData } from "@/api/oa";

export default {
  name: "budgetDetails",
  data() {
    return {
      id: this.$route.query.id,
      budget: {},
      toast: null
    }
  },
  created() {
    this.toast = this.$toast.loading({
      mask: false,
      message: "加载中...",
      duration: 0
    });
    this.getDetailsData();
  },
  methods: {
    getDetailsData() {
      fetchData("getBudgetDetails", {
        code: this.id
      }).then(response => {
          this.toast.clear();
          if (response.data.success === true) {
            this.budget = response.data.data;
          }
        }).catch(() => {
          this.toast.clear();
        });
    }
  },
  beforeDestroy() {
    this.toast.clear();
  }
};
</script>
<style>
  .budget_box .status_span .blue{
    color: #44cef6;
  }
  .budget_box .status_span .green{
    color: #2edfa3;
  }
  .budget_box .status_span .red{
    color:#ff4c00;
  }
  .budget_box .status_span .orange{
    color:#ffa400;
  }
  .budget_box .status_span .purple{
    color:#8d4bbb;
  }
  .budget_box .status_span .grey{
    color:grey;
  }
  .page .budget_box {
    padding-top: 12px;
    border-bottom: 1px solid transparent;
  }
</style>




